
import { Box, Checkbox, FormControlLabel, Grid, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquare } from '../../../assets/icons/add-square-green.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'
import { ReactComponent as Bag } from '../../../assets/icons/bag-button.svg'

import { ReactComponent as Rectangle } from '../../../assets/icons/Group 1686551338.svg'

import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import InputTextField from '../../../components/input/inputTextField';
import UploadFile from '../../../components/upload/UploadFile';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import { ThesisTypeApi } from '../../../api/thesis-type/thesis-type.api';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { ThesisBookApi } from '../../../api/thesis-book/thesis-book.api';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { timeToView } from '../../../utils/date.utils';
import moment from 'moment';
import { ExaminationCalendarStudentApi } from '../../../api/examination-calendar-student/examination-calendar-student.api';
import StepperCustom from '../../../components/step/Stepper';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import ModalCustom from '../../../components/modal/ModalCustom';
import { EmployeeApi } from '../../../api/employee/employee.api';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
const defaultState = {
    id_examination_calendar: 0,
    examination_name: '',
    examination_desc: '',
    examination_start_date: undefined,
    examination_end_date: undefined,
    examination_calendar_start_date: undefined,
    examination_calendar_end_date: undefined,
    examination_calendar_status: "DRAFT",
    id_examination_calendar_files: []
}
export default function DetailExamination() {
    const { t } = useTranslation();
    const allStep: any[] = useMemo(() => [
        { name: t('ข้อมูลการจอง'), isAccept: true, icon: null, disabled: false },
        { name: t('รายละเอียดการอนุมัติ'), isAccept: true, icon: null, disabled: false },

    ], [t,]);
    const location = useLocation()
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const mode = search_params.get("mode");
    const { id, id_examination_calendar_student } = useParams();
    const [open, setOpen] = useState<boolean>(false)
    const [openApprove, setOpenApprove] = useState<boolean>(false)

    const [remark, setRemark] = useState<string>('');
    const [advisor, setAdvisor] = useState<any[]>([]);
    const [thesisCategory, setThesisCategory] = useState<any[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [step, setStep] = useState<any>(0);

    const [form, setForm] = useState<any>(defaultState)
    const [formApprove, setFormApprove] = useState<any>()
    const handleUpdate = async (file: any, index: number) => {

        setForm({
            ...form, files_thesis_book: form?.files_thesis_book?.map((item: any, i: number) => {
                return i === index ? file[0] : item
            })
        })


    }
    const getAdvisor = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
        };

        const res = await EmployeeApi.list(condition);
        const data = res.data;
        if (data.status < 300) {
            setAdvisor(data.data.items);
        } else {
            setAdvisor([]);
        }
    }
    const getDetail = async () => {

        const res = await ExaminationCalendarStudentApi.findById(id_examination_calendar_student);
        const data = res.data
        if (data?.status < 300) {
            console.log(data);
            setForm(data.data)
            if (data.data?.examination_calendar_student_status === 'APPROVE') {
                setStep(1)
            }

        } else {
        }
    }
    const getDetailApprove = async () => {

        const res = await ExaminationCalendarStudentApi.findByIdApprove(id_examination_calendar_student);
        const data = res.data
        if (data?.status < 300) {
            console.log(data);
            setFormApprove(data.data)
            // if (data.data?.examination_calendar_student_status === 'APPROVE') {
            //     setStep(1)
            // }

        } else {
        }
    }

    const handleApprove = async (status:any) => {
        const body = {
            examination_calendar_student_status: status || "APPROVE",
            examination_calendar_student_approve_remark: remark || ""
        }

        await ExaminationCalendarStudentApi.approve(body, id_examination_calendar_student).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(status === 'APPROVE' ? 'อนุมัติคำร้องขอจองวันสอบแล้ว' : t('ไม่อนุมัติคำร้องขอจองวันสอบ'))
                getDetail()
                getDetailApprove()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    const handleApproveDetail = async () => {
        const body = {
            examination_calendar_student_approve_start_time: `${moment(formApprove?.examination_calendar_student_approve_date).format('YYYY-MM-DD')}T${formApprove?.examination_calendar_student_approve_start_time}`,
            examination_calendar_student_approve_end_time: `${moment(formApprove?.examination_calendar_student_approve_date).format('YYYY-MM-DD')}T${formApprove?.examination_calendar_student_approve_end_time}`,
            last_check_employee: formApprove?.last_check_employee ? 1 : 0,
            employee_examination_calendars: formApprove?.employee_examination_calendars?.map((item: any) => {
                return {
                    id_employee: item?.id_employee,
                    first_name: item?.first_name,
                    last_name: item?.last_name,
                    position: item?.position_name,
                    mobile: item?.mobile || '',
                    email: item?.email || '',
                }
            })
        }

        console.log(body);
        await ExaminationCalendarStudentApi.approveDetail(body, formApprove?.id_examination_calendar_student_approve).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('อนุมัติคำร้องขอจองวันสอบ เรียบร้อยแล้ว'))
                navigate(routeName.cms.ListExaminationDate.replace(':id', `${id}`))
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    useEffect(() => {
        if (id_examination_calendar_student) {
            getDetail()
            getAdvisor()
            getDetailApprove()
        }


    }, [])


    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ห้องสมุดวิทยานิพนธ์"),
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: 'รายการขอจองวันสอบ',
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                    {
                        name: 'รายละเอียดการขอจองวันสอบ',
                        key: "3",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },

                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{'รายละเอียดการขอจองวันสอบ'}</Typography>
                {(step === 1 && mode !== 'VIEW') && <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'end'
                }}>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                navigate(routeName.cms.ListExaminationDate.replace(':id', `${id}`))

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                handleApproveDetail()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />
                    </div>
                </div>}
            </section>
            {form?.examination_calendar_student_status === 'APPROVE' &&
                <section className='w-full'>
                    <StepperCustom
                        sx={{ maxWidth: "400px" }}
                        step={step}
                        setStep={(num: number) => {
                            // dispatch(setStep(num));
                            setStep(num)
                        }}
                        stepLabel={allStep}
                    // view={is_accept}
                    />
                </section>}
            {step === 0 &&
                <section className="my-4">
                    <Grid container spacing={2}>
                        {form?.examination_calendar_student_approve_remark &&<Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('หมายเหตุไม่อนุมัติการจอง')}
                                placeholder={t('หมายเหตุไม่อนุมัติการจอง')}

                                value={form?.examination_calendar_student_approve_remark || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    " "
                                }
                                minRow={6}
                                multiline
                                inputHeight={'auto'}
                                disabled
                            />
                        </Grid>}
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('ผู้ทำรายการ')}
                                placeholder={t('ผู้ทำรายการ')}

                                value={form?.student_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('รหัสประจำตัวนักศึกษา')}
                                placeholder={t('รหัสประจำตัวนักศึกษา')}
                                value={form?.student_no || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('ระดับ')}
                                placeholder={t('ระดับ')}
                                value={form?.degree_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('คณะ')}
                                placeholder={t('คณะ')}
                                required
                                value={form?.faculty_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('เรื่อง')}
                                placeholder={t('เรื่อง')}
                                value={form?.examination_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputDatePicker heading='วันที่เริ่มต้นกิจกรรม' value={form?.examination_start_date || ''}
                                onChange={(e: any) => {
                                }} disabled />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputDatePicker heading='วันที่สิ้นสุดกิจกรรม' value={form?.examination_end_date || ''}
                                onChange={(e: any) => {
                                }} disabled />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        > <InputTextField
                                heading={t('เวลาเริ่มต้นกิจกรรม')}
                                placeholder={t('เวลาเริ่มต้นกิจกรรม')}
                                required
                                value={timeToView(form?.examination_start_date) || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                                type='time'
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        > <InputTextField
                                heading={t('เวลาสิ้นสุดกิจกรรม')}
                                placeholder={t('เวลาสิ้นสุดกิจกรรม')}
                                required
                                value={timeToView(form?.examination_end_date) || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                                type='time'
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputDatePicker heading='วันที่ต้องการจอง' value={form?.examination_calendar_date || ''}
                                onChange={(e: any) => {
                                }} disabled />


                        </Grid>
                    </Grid>

                </section>
            }
            {step === 1 &&
                <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                    <Typography>วันที่และเวลาที่อนุมัติ</Typography>
                    <Grid container spacing={2}>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputDatePicker heading='วันที่' value={formApprove?.examination_calendar_student_approve_date || ''}
                                onChange={(e: any) => {
                                    setFormApprove({ ...formApprove, examination_calendar_student_approve_date: moment(e).format('YYYY-MM-DD') })

                                }} disabled />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        > <InputTextField
                                heading={t('เวลาเริ่มต้น')}
                                placeholder={t('เวลาเริ่มต้น')}
                                required
                                value={formApprove?.examination_calendar_student_approve_start_time || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setFormApprove({ ...formApprove, examination_calendar_student_approve_start_time: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                type='time'
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        > <InputTextField
                                heading={t('เวลาสิ้นสุด')}
                                placeholder={t('เวลาสิ้นสุด')}
                                required
                                value={formApprove?.examination_calendar_student_approve_end_time || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setFormApprove({ ...formApprove, examination_calendar_student_approve_end_time: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                type='time'
                            />
                        </Grid>


                    </Grid>
                    <Typography>ข้อมูลคณะกรรมการ</Typography>
                    <FormControlLabel control={<Checkbox checked={formApprove?.last_check_employee} onChange={(e) => setFormApprove({ ...formApprove, last_check_employee: e.target.checked })} />} label="ใช้ข้อมูลคณะกรรมการจากจองครั้งล่าสุดของผู้ดำเนินการจอง" />
                    <Box sx={{ borderRadius: "10px", border: '1px solid #4A4A4A', overflow: 'hidden' }}>
                        <Box

                            sx={{
                                borderRadius: "8px",
                                backgroundColor: "#4A4A4A",
                                padding: "10px 16px",
                                fontWeight: "bold",
                                display: 'flex'
                            }}
                        >
                            <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', padding: '0px 10px' }}>
                                <Typography sx={{ fontWeight: "bold", color: '#fff', width: `${100 / 5}%` }}>{t('ชื่อ - นามสกุล')}</Typography>
                                <Typography sx={{ fontWeight: "bold", color: '#fff', width: `${100 / 5}%`, textAlign: 'center' }}>{t('ตำแหน่งงานปัจจุบัน')}</Typography>
                                <Typography sx={{ fontWeight: "bold", color: '#fff', width: `${100 / 5}%`, textAlign: 'center' }}>{t('เบอร์โทร')}</Typography>
                                <Typography sx={{ fontWeight: "bold", color: '#fff', width: `${100 / 5}%`, textAlign: 'center' }}>{t('อีเมลองค์กร')}</Typography>
                            </Box>
                            {mode !== 'VIEW' && <Box sx={{ background: "#fff", border: '1px solid #7e7e7e', borderRadius: '8px', padding: '5px 10px', cursor: "pointer" }}>
                                <div style={{ width: `${100 / 5}%` }}> <Typography onClick={(e) => {
                                    setOpen(true)
                                }}>เพิ่ม</Typography></div>
                            </Box>}
                        </Box>
                        <Box sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px', padding: '5px 10px' }}>
                            {formApprove?.employee_examination_calendars?.length > 0 ? formApprove?.employee_examination_calendars?.map((item: any, index: number) => {
                                return (
                                    <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', boxShadow: '0px 0px 4px 0px #10182829', padding: '10px', borderRadius: '8px', }} >
                                        <Typography sx={{ width: `${100 / 5}%` }}>{item?.fullname || `${item?.employee?.first_name || item?.first_name } ${item?.employee?.last_name || item?.last_name}`}</Typography>
                                        <Typography sx={{ width: `${100 / 5}%`, textAlign: 'center' }}>{item?.position_name || item?.position || '-'}</Typography>
                                        <Typography sx={{ width: `${100 / 5}%`, textAlign: 'center' }}>{item?.tel || '-'}</Typography>
                                        <Typography sx={{ width: `${100 / 5}%`, textAlign: 'center' }}>{item?.email || '-'}</Typography>
                                        <div style={{ width: `${100 / 5}%`, display: 'flex', justifyContent: 'center' }}>
                                            <OptionsButtonCustom
                                                enableView={mode !== 'VIEW'}
                                                enableEdit={mode !== 'VIEW'}
                                                enableDelete={mode !== 'VIEW'}
                                                onViewClick={() => {

                                                }}
                                                onCopy={() => {

                                                }}
                                                onEditClick={() => {

                                                }}
                                                onDeleteClick={() => {
                                                    setFormApprove({ ...formApprove, employee_examination_calendars: formApprove?.employee_examination_calendars?.filter((x: any, i: number) => i !== index) })
                                                }} />
                                        </div>
                                    </Box>
                                )
                            }) : <Typography>ไม่มีข้อมูล...</Typography>}

                        </Box>
                    </Box>
                </div>}
            {form?.examination_calendar_student_status === 'WAIT_FOR_CONSIDER' &&
                <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                    <ButtonOutlined
                        onClick={() => {
                            // navigate(routeName.cms.MeetingCalendar);
                            // navigate(routeName.cms.MeetingCaledarDetail.replace(':id', `${id}`));
                             navigate(routeName.cms.ListExaminationDate.replace(':id', `${id}`))
                        }}
                        buttonName="ย้อนกลับ"
                        btnProps={{
                            width: "150px",
                        }}
                    />


                    {mode !== 'VIEW' && <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            handleApprove('APPROVE')
                        }}
                        mode="success"
                        buttonName="อนุมัติ"
                        btnProps={{
                            width: "150px",
                        }}
                    />}
                    {mode !== 'VIEW' && <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            // handleApprove()
                            setOpenApprove(true)
                            setRemark('')
                        }}
                        mode="success"
                        buttonName="ไม่อนุมัติ"
                        btnProps={{
                            width: "150px",
                            bg: 'red'
                        }}
                    />}
                </section>}
            <ModalCustom title={t('ไม่อนุมัติคำร้องขอจองวันสอบ')} subTitle={t('กรุณาระบุหมายเหตุ')} open={openApprove} component={
                <div className='flex flex-col gap-4'>
                    
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('หมายเหตุ')}
                            placeholder={t('หมายเหตุ')}
                            required
                            value={remark || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setRemark(e.target.value)
                            }}
                            helperText={
                                ""
                            }
                            inputHeight={'auto'}
                            minRow={6}
                            multiline
                        />

                    </article>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpenApprove(false)
                                setRemark('')

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                
                                setOpenApprove(false)
                                handleApprove('REJECT')
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                            btnProps={{
                                bg:'red'
                            }}
                        />
                    </div>
                </div>
            } />
            <ModalCustom title={t('เพิ่มข้อข้อมูลคณะกรรมการ')} subTitle={t('COUNRSE_OF_STUDT.SUBTITLE')} open={open} component={
                <div className='flex flex-col gap-4'>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <AutocompleteSelect
                            heading={t('ชื่อ-นามสกุล หรือ เลขประจำตัวเจ้าหน้าที่')} placeholder={t('ชื่อ-นามสกุล หรือ เลขประจำตัวเจ้าหน้าที่')}
                            freeSolo
                            labelId={''} options={advisor}
                            getOptionLabel={(option: any) => `${option?.fullname}` || ""}
                            onChange={(e: any, value: any) => {
                                console.log(value);
                                setFormApprove({ ...formApprove, advisor: value })
                            }}
                            value={formApprove?.advisor}
                        />
                    </article>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('ชื่อ-นามสกุล')}
                            placeholder={t('ชื่อ-นามสกุล')}
                            required
                            value={formApprove?.advisor?.fullname || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />

                    </article>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('ตำแหน่งงานปัจจุบัน')}
                            placeholder={t('ตำแหน่งงานปัจจุบัน')}
                            required
                            value={formApprove?.advisor?.position_name || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />

                    </article>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('เบอร์โทร')}
                            placeholder={t('เบอร์โทร')}
                            required
                            value={formApprove?.advisor?.tel || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />

                    </article>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('อีเมลองค์กร')}
                            placeholder={t('อีเมลองค์กร')}
                            required
                            value={formApprove?.advisor?.email || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />

                    </article>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setFormApprove({ ...formApprove, advisor: null, })

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                setFormApprove({
                                    ...formApprove,
                                    employee_examination_calendars: formApprove?.employee_examination_calendars?.length > 0 ?
                                        [...formApprove?.employee_examination_calendars, formApprove?.advisor]
                                        : [formApprove?.advisor], advisor: null
                                })
                                setOpen(false)
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />
                    </div>
                </div>
            } />
        </div >
    )
}
